// The cycle set as current in Settings > Cycles, rendered into the page head by layouts/_head
export const getCurrentCycleId = () => {
  const element = document.head.querySelector('meta[name="current-cycle-id"]');
  return element ? element.getAttribute('content') : null;
};
